export default __webpack_public_path__ + "static/future3_campus-d83bffa061f20682f11cbed0ec0199d9.svg";